import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
import {
  defaultFontBold,
  defaultFontItalic,
  defaultFontNormal,
  georgia,
} from "../utils/styling";

export const getAppendix2Paragraphs = () => {
  const paragraphs = [
    {
      segments: [
        {
          text: "This appendix contains an outline of some of the key elections that can be made in relation to the application of the Corporate Interest Restriction legislation.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Disapply statutory order of disallowance of tax-interest expense amounts - s377(3) TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "In the absence of an election, where the amount to be disallowed is less than a company's total Tax-Interest expense amounts for the period, the legislation requires that Tax-Interest expense amounts are disallowed in the following order:",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 1,
      segments: [
        {
          text: "Non-trading loan relationship debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 1,
      segments: [
        {
          text: "Non-trading derivative contract debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 1,
      segments: [
        {
          text: "Trading loan relationship debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 1,
      segments: [
        {
          text: "Trading derivative contract debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 1,
      segments: [
        {
          text: "Other tax-interest expense amounts within Condition C of s382 (finance leases, debt factoring, service concession arrangements)",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "However, a company can specify which particular tax-interest expense amounts are disallowed in an accounting period by making an election under s377. The election can be made in the company’s tax return, and can be revoked.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "Disapply statutory order of reactivation of tax-interest expense amounts - s380(3) TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "In the absence of an election, where the amount to be reactivated is less than a company's total of Tax-Interest expense amounts brought forward, the legislation requires that Tax-Interest expense amounts are reactivated in the following order:",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 2,
      segments: [
        {
          text: "Non-trading loan relationship debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 2,
      segments: [
        {
          text: "Non-trading loan relationship debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 2,
      segments: [
        {
          text: "Trading loan relationship debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 2,
      segments: [
        {
          text: "Trading derivative contract debits",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "number",
      bulletNum: 2,
      segments: [
        {
          text: "Other tax-interest expense amounts within Condition C of s382 (finance leases, debt factoring, service concession arrangements)",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "However, a company can specify which particular Tax-Interest expense amounts are reactivated in an accounting period by making an election under s380. The election can be made in the company’s tax return, and can be revoked.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "Election for amortised cost basis for fair valued creditor relationships - s456/457 TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "A company can elect that the Tax-Interest income and expense amounts in respect of all of its creditor relationships that are fair-valued may be determined on an amortised cost basis of accounting.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election was introduced with the intention of reducing the compliance burden of Insurance groups in a long-term net interest income position, but subject to significant volatility due to fair value accounting. It must be made within 12 months of the end of the first period to which it is intended to apply.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Securitisation company - transfer of tax liability",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "This provision allows the Commissioners to introduce regulations entitling a UK group company which is party to a capital market arrangement (broadly, a securitisation company) and which has a corporation tax liability, and another UK group company, to make a joint election transferring the tax liability to the other UK group company.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "At this time, no regulations have been made under this provision and so it is not currently possible to make such an election.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Election to apply the Disregard Regulations to pre-1 April 2020 derivative contracts - Para 31, Schedule 5, Finance (No. 2) Act 2017",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "This is an irrevocable election that had to be made before 1 April 2018. Where the election was made by all non-dormant UK group companies in a worldwide group, it deemed Disregard Regulations 7, 8 and 9 to have effect for all derivative contracts entered into by the company before 1 April 2020, solely for the purposes of calculating Tax-Interest income and expense amounts and Tax-EBITDA amounts.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Group Ratio Elections",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "Group ratio election - Para 13, Schedule 7A, TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The Group Ratio election can be beneficial to groups that are highly leveraged with debt issued to unrelated third parties. Where the election applies, the 30% fixed ratio is replaced by the ratio of the worldwide group’s Group Interest to Group EBITDA (both terms defined in the legislation). If this ratio is higher than 30%, the Interest Allowance of the group may therefore be increased.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Where the election is made, the fixed ratio debt cap of the group is also replaced by a group ratio debt cap, which excludes certain items including related party debt, results dependent securities and equity notes.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election can be made in a Corporate Interest Restriction return and applies only in relation to that return (i.e. it is an annual election and can be revoked or included in amended returns).",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "There are also a number of additional elections that can be made to modify the application of the CIR rules under the Group Ratio method, many of which can have a substantial impact on the calculation of the Group Ratio. These are covered below.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Group ratio blended election  - Para 14, Schedule 7A, TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The Group ratio blended election applies to allow a higher group ratio to apply in certain circumstances where investors in the group are highly leveraged. Where the election applies, the group ratio percentage is broadly replaced by a blended ratio based on the investors percentage investment multiplied by the higher of (i) 30%, (ii) the group ratio of the group, and (iii) the investors’ group ratio. When the election is made, the group ratio debt cap is also amended, depending on which of the options above is fed into the group ratio percentage.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election applies only in relation to the return in which the election is made (i.e. it is an annual election and can be revoked or included in amended returns).",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Group EBITDA (chargeable gains) election - Para 15, Schedule 7A, TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The Group EBITDA (chargeable gains) election applies to modify the amount of capital disposals that are included in Group EBITDA. The election is intended to more closely align Group-EBITDA to Tax-EBITDA, by allowing the use of tax-specific adjustments including indexation, March 1982 basis adjustments, rollover relief and (through the carry forward of relevant losses) losses made on previous disposals whilst the election has been in force.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Broadly this is achieved by calculating the Group EBITDA in respect of capital disposals under UK tax principles subject to certain adjustments (e.g. SSE and double tax relief have no effect) instead of including only the excess of disposal proceeds over accounting cost.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election is made in a Corporate Interest Restriction return and is irrevocable.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Interest allowance (alternative calculation) election - Para 16, Schedule 7A, TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The Interest Allowance (alternative calculation) election applies to modify the calculation of Adjusted Net Group-Interest Expense (“ANGIE”) and Group-EBITDA. As it modifies the calculation of ANGIE, it also impacts the “debt cap” under both the fixed and group ratio methods. The election is intended to more closely align ANGIE to Tax-Interest and Group-EBITDA to Tax-EBITDA, by requiring certain tax-specific adjustments.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Whilst the specific adjustments are not included in this appendix, the areas in which some of the key adjustments arise are set out below:",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "ANGIE",
          font: defaultFontItalic,
          break: 1,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Capitalised interest is adjusted to be more closely aligned with the tax treatment for GAAP-taxable assets.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "Group-EBITDA",
          font: defaultFontItalic,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Employers’ pension expenses are adjusted to be more closely aligned with tax deductions (including spreading) for UK defined benefit pension schemes;",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Employee share scheme expenses are more closely aligned with the tax deductions that would be available if the employer was subject to Corporation Tax; and",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "When a company changes its accounting policy, the income statement amounts are adjusted to more closely align to the tax position if the whole group was a single company subject to Corporation Tax.",
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election is made in a Corporate Interest Restriction return and is irrevocable.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Interest allowance (non-consolidated investment) election - Para 17, Schedule 7A, TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The Interest allowance (non-consolidated investment) election is intended to amend the calculation of Group Interest and Group EBITDA in relation to certain non-consolidated investments. The election broadly acts to remove any amounts (e.g. profits after tax) included in respect of the investment in the non-consolidated investment and the impact of any loans made to them. Instead, the appropriate portion of the non-consolidated investment’s Group EBITDA (ignoring loans from the worldwide group) is included, and ANGIE/QNGIE are increased by the appropriate portion of the ANGIE/QNGIE of the non-consolidated investment. The investments to which the election can apply were extended with effect from 1 April 2023, but care is required to ensure that the investment meets one of the relevant conditions.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election is made in a Corporate Interest Restriction return on an investment by investment basis and is revocable.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Interest allowance (consolidated partnership) election - Para 18, Schedule 7A, TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The Interest allowance (consolidated partnership) election is intended to provide groups with an option to treat consolidated partnerships as though they were a joint venture in certain circumstances when they are consolidated and do not have a subsidiary that is a company. Where the election is made the partnership is treated as though it was “equity accounted” for.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election is made in a Corporate Interest Restriction return, must specify the partnerships it is intended to apply to, and is irrevocable.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Qualifying Infrastructure Company Elections",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "Qualifying infrastructure company (“QIC”)- s433 TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The qualifying infrastructure company (“QIC”) election is an election intended to exempt Tax-Interest amounts of companies that broadly generate all but an insignificant proportion of their income and assets from qualifying infrastructure assets or ancillary services in relation to those assets. Qualifying infrastructure assets are broadly assets forming part of the infrastructure of the UK or buildings let / to be let on a short term basis to unrelated parties.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election can also apply to certain group companies that generate all but an insignificant proportion of their income and assets from shareholdings in or loans to qualifying infrastructure companies.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Where a QIC election has been made certain Tax-Interest expense amounts (including interest payable to third parties and certain “grandfathered” pre 13 May 2016 loan relationships) are excluded from the rules and thus deductible subject to other anti-avoidance provisions. However, the Tax-EBITDA, and Tax-Interest income amounts of the company are also excluded, and adjustments are required to other amounts including ANGIE.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "An election must be made before the end of the accounting period to which it is to have effect and cannot be revoked for 5 years.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Qualifying infrastructure company - group election - s435 TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "This election can be made by two or more companies in the same worldwide group and modifies the QIC election for those companies by deeming them to have the assets and income of the other companies named in the election.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "It applies an “all or nothing” approach such that, where one company fails to meet the definition of a QIC, all of the companies subject to the election are also deemed to fail and modifies the time at which certain companies can revoke a QIC election.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election can only be made on a prospective basis and can be withdrawn at any time on a prospective basis.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Qualifying infrastructure company - joint venture companies election - s444 TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "This election applies where a QIC is the ultimate parent of a worldwide group and broadly applies to modify the qualifying infrastructure company rules to prevent non-QIC investors (for example by only excluding a proportion of Tax-EBITDA and Tax-Interest Income).",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Where the ultimate parent is the ultimate parent of a multi-company worldwide group, all of the companies in the group must be QICs.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Compliance Elections:",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "Appointment of a reporting company - Para 1 Schedule 7A TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The appointment of a reporting company is covered in the “Reporting Company” section in the main body of the report.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Consenting company - Para 10 Schedule 7A TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "The notification as to whether a company is a “consenting company” is covered in the “Consenting / Non-Consenting Companies” section in the main body of the report.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Abbreviated return election - Para 19 Schedule 7A TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "This election can only be made for a CIR return where there is no disallowance of interest expense. It is covered in the “Nature of return” section in the main body of the report.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Election not to treat consolidated IAS financial statements as deemed to be drawn up for the relevant period - s484(3) TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "This election can be made where the ultimate parent of a worldwide group draws up individual entity financial statements in respect of a period for which it is the ultimate parent of the group, but does not draw up consolidated financial statements. In the absence of an election, IAS financial statements of the worldwide group are deemed to be drawn up for the relevant period. However, if the election is made, the group is not deemed to draw up accounts, such that there is an “accounts free period”. This allows the group, inter alia, to make an election to alter the deemed period of account (see below).",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The election must specify the date on which it takes effect, which must be after the date the election is made. It then applies in relation to financial statements ending on or after the date specified in the election. The election is irrevocable.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "Election to alter deemed period of account where no actual financial statements drawn up - s486 TIOPA 2010",
          font: defaultFontItalic,
          underline: true,
          break: 1,
        },
        {
          text: "Where no actual financial statements of the worldwide group are drawn up (including where an election is made under s484(3) as set out above), accounts are deemed to be drawn up under s485 TIOPA 2010 in respect of the accounts-free period. The legislation includes specific provisions that determine the day when an accounts-free period is deemed to end (“end day”), to ensure that a return is required. S486 TIOPA 2010 allows for a group to over-rule the default accounts-free period in s485 to ensure that the deemed period better aligns with the group (e.g. by aligning it to the period end of UK group companies).",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The chosen “end day” must fall within an accounts-free period and be less than 18 months after the start of the deemed period of account. The election is irrevocable.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "This document has been prepared only for the group named above and solely for the purpose and on the terms agreed. We accept no liability (including for negligence) to anyone else in connection with this document, and it may not be provided to anyone else.",
          font: georgia,
          break: 5,
        },
        {
          text: "© 2025 PricewaterhouseCoopers LLP. All rights reserved. In this document, 'PwC' refers to the UK member firm, and may sometimes refer to the PwC network. Each member firm is a separate legal entity. Please see www.pwc.com/structure for further details.",
          font: georgia,
          break: 1,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Appendix 2 - Elections"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
